import { styled } from '../../styled/styled-components'

export const StyledGrid = styled.div`
  div[class^='GridElement__Grid'] {
    justify-content: space-evenly;
    align-items: center;
  }
  p[class^='Description'] {
    color: unset;
  }
`
export const StyledFooter = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
`
